import { render, staticRenderFns } from "./ListaFornecedor.vue?vue&type=template&id=045b6487"
import script from "./ListaFornecedor.vue?vue&type=script&lang=js"
export * from "./ListaFornecedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports